import { render } from "./OrderDetails.vue?vue&type=template&id=25671cde"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script